import { Route, Routes } from 'react-router-dom';

import DashboardLayout from '@/components/layout/layout';
import AddCourses from '@/pages/courses/add-course';
import Courses from '@/pages/courses/courses';
import AddGroup from '@/pages/groups/add-group';
import Group from '@/pages/groups/group';
import Groups from '@/pages/groups/groups';
import MainPage from '@/pages/main';
import PaymentHistory from '@/pages/payment-history';
import AddStudent from '@/pages/students/add-student';
import Students from '@/pages/students/students';
import AddTeacher from '@/pages/teachers/add-teacher';
import Teacher from '@/pages/teachers/teacher';
import Teachers from '@/pages/teachers/teachers';
import Analytics from './analytics';
import CreateAccount from './create-account';
import GroupExam from './groups/exam';
import GroupTask from './groups/tasks/task';
import LeadsPage from './Leads';
import LogsPage from './logs';
import AddRoom from './rooms/add-room';
import Rooms from './rooms/rooms';
import Settings from './settings';
import Student from './students/student';

function Dashboard() {
  // TODO: app performance https://chatgpt.com/c/68b89da5-5f20-8320-a5fa-f2c0087ea11c
  return (
    <DashboardLayout>
      <Routes>
        <Route path="/:username/:password" />
        <Route path="/" element={<MainPage />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/add-course" element={<AddCourses />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/add-room" element={<AddRoom />} />
        <Route path="/teachers" element={<Teachers />} />
        <Route path="/teachers/:teacherId" element={<Teacher />} />
        <Route path="/add-teacher" element={<AddTeacher />} />
        <Route path="/add-student" element={<AddStudent />} />
        <Route path="/students" element={<Students />} />
        <Route path="/students/:studentId" element={<Student />} />
        <Route path="/groups" element={<Groups />} />
        <Route path="/groups/:groupId" element={<Group />} />
        <Route path="/groups/:groupId/task/:taskId" element={<GroupTask />} />
        <Route path="/groups/:groupId/exam/:examId" element={<GroupExam />} />
        <Route path="/add-group" element={<AddGroup />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/payment-history" element={<PaymentHistory />} />
        <Route path="/logs" element={<LogsPage />} />
        <Route path="/leads" element={<LeadsPage />} />
        <Route path="/settings" element={<Settings />} />

        <Route path="/create-account" element={<CreateAccount />} />
      </Routes>
    </DashboardLayout>
  );
}

export default Dashboard;
